module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTimeLine || _vm.showBookingTimer),
      expression: "showTimeLine || showBookingTimer"
    }],
    class: 'wrapper theme--' + _vm.theme
  }, [(_vm.showTimeLine) ? _c('div', {
    staticClass: "flex"
  }, [_c('ul', {
    staticClass: "timeline",
    attrs: {
      "id": "timeline",
      "aria-label": "Avklarade steg i bokningen"
    }
  }, _vm._l((_vm.steps), function(step, key) {
    return _c('li', {
      key: key,
      class: 'li complete--' + (step.complete) + ' next-complete--' + (_vm.steps[key + 1] ? _vm.steps[key + 1].complete : '')
    }, [_c('div', {
      class: {
        status: true, clickable: _vm.clickable(step)
      },
      on: {
        "click": function($event) {
          return _vm.goTo(step)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(step.title))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('BookingTimer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBookingTimer),
      expression: "showBookingTimer"
    }],
    ref: "bookingTimer",
    on: {
      "update": _vm.update
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b8a44cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Timeline.vue
// module id = 894
// module chunks = 0